import React from "react";
import { Grid, Header, Icon, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
    return (
        <Grid centered={true}>
            <Grid.Row />
            <Grid.Row>
                <Header as="h1" icon={true} textAlign="center">
                    <Icon name="sun" />
                    Pagina non trovata
                    <Header.Subheader>
                        Riprova
                    </Header.Subheader>
                </Header>
            </Grid.Row>
            <Grid.Row>
                <Button as={Link} to='/portal' primary>Torna alla pagina principale</Button>
            </Grid.Row>
        </Grid>
    );
};

export default PageNotFound;
